export default "/_next/static/chunks/fonts/Outfit ExtraLight-8ec1fa62e1640de45a7918b3b6694b61.ttf";